<span :class="className" v-safe-html="getModel"></span>